import Flux from 'lib/flux';

const BookingRequestConstants = Flux.createConstants({
  serviceMessages: [
    'SAVE',
    'COMMIT',
    'APPLY_DISCOUNT',
    'REMOVE_DISCOUNT',
    'FETCH_SUMMARY',
    'SET_AUTH_STATUS',
    'AUTH_COMPLETED',
    'ADD_STRIPE_CARD_ELEMENT',
    'STRIPE_PAYMENT_ERROR',
    'RESET_STRIPE_AUTH',
    'SET_STRIPE_TOKEN',
  ],
  messages: ['CHANGE', 'STATUS_COMMITTED'],
});

export default BookingRequestConstants;
